import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';


import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { AppService } from 'src/app/app.service';
import { AuthService } from './auth.service';

import * as _ from 'lodash';
import moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class EntityService {

	appConfig = environment.appConfig;


	constructor(
		private httpClient: HttpClient,
		private appService: AppService,
		private authService: AuthService,
	) {
	}


	public getUserInfo(withWallet?) {
		return this.authService.getUserInfo(withWallet);
	}

	public getUserWallet() {
		return this.authService.getUserWallet();
	}

	public getUserHistory() {
		let that = this;
		return this.get('/online-shopper/customers/current/history').then((response) => {
			if (!response) response = [];
			let serviceTypes = [];


			let members = {
				delivery: { icon: 'directions_bike', img: this.appService.images.his_delivery },
				takeaway: { icon: 'shopping_basket', img: this.appService.images.his_ta },
				seated: { icon: 'event_seat', img: this.appService.images.his_pay }
			}

			let ret = _.map(response.history, order => {
				let siteId = order.organization && order.organization._id;
				let member = members[order.serviceType] || members.takeaway;
				if (serviceTypes.indexOf(order.serviceType) == -1) {
					serviceTypes.push(order.serviceType);
				}

				return {
					"_id": order.tlog,
					"organization": siteId,
					"name": order.organization && order.organization.name,
					"date": order.closed,
					"service": "order",
					"serviceType": order.serviceType,
					"amount": order.totalAmount,
					"billId": order.tlog,
					"order": order.order,
					"logo": order.organization?.smallLogoUrl,
					"_o": member
				}
			});
			ret = _.orderBy(ret, ['date'], ['desc']);
			that.appService.account.history = ret;
			return ret;
		});
	}

	public getSiteConfig(siteId) {
		const promises = [
			this.get('/online-shopper/configuration', null, { 'ros-organization': siteId }),
			this.get(`/organizations/${siteId}`).catch(err => { })
		]
		return Promise.all(promises).then(response => {
			const ret = response[0];
			this.fixConfigRegressions(ret);
			//if (this.appService.appConfig.isDev) _.set(ret, 'notifications.allowForeignNumbers', true);
			ret.config.allowForeignNumbers = _.get(ret, 'notifications.allowForeignNumbers', false);
			ret.config.screenRecorder = ret.screenRecorder;

			this.appService.allowForeignNumbers(ret.config.allowForeignNumbers);
			ret.logoURL = _.get(response[1], 'smallLogo.url');
			return ret;
		});
	}

	fixConfigRegressions(site) {
		const config = site.config;
		const deliveryGratuity = _.get(config, 'settings.enableDeliveryGratuity');
		config.tableOrdering = {defaultTip: 0, ...site.tableOrdering};
		if (!_.isUndefined(deliveryGratuity)) {
			delete config.settings.enableDeliveryGratuity;
			_.set(config.delivery, 'enableGratuity', deliveryGratuity);
			switch (this.appService.region) {
				case "US":
					_.set(config.takeaway, 'enableGratuity', deliveryGratuity);
					_.set(config.eatin, 'enableGratuity', deliveryGratuity);
					break;
			}
		}
	}

    public getOrderById(siteId, orderId:string) {
        let params:any = {};
		if (orderId && orderId.length) {
			if (orderId.length === 6) params.shortId = orderId.toUpperCase();
			else params.orderId = orderId;
        } else {
            return Promise.reject({
                type: 'ERROR',
                message: this.appService.translate("SERVER_MESSAGES.INVALID_ORDER_ID")
            });
        }

        return this.get(`/online-shopper/bills`, params, { 'ros-organization': siteId }).then(response => {
            return response[0];
        });
    }

	public getOrderBill(dataRow) {
        return this.get(`/online-shopper/receipts`, { tlogId: dataRow.billId }, { 'ros-organization': dataRow.organization}).then(response => {
			return _.get(response, '[0].printData');
		});
	}

	public addPaymentMethodToWallet(ccinfo) {
		return this.post('/online-shopper/customers/current/wallet/payments', ccinfo)
		.then(() => {
			this.appService.sendAnalyticsEvent('add_payment_info', {});
			return this.getUserWallet()
			.then(res => {
				return res;
			});
		}).catch(e => {
			throw (e);
		});
	}

    public addCvvToPaymentMethod(paymentId, cvv, idCard?) {
        if (!this.appService.user.wallet || !this.appService.user.wallet.payments || !this.appService.user.wallet.payments.length) {
            return Promise.resolve();
        }

		if (idCard && idCard != 'MISSING') {
			this.appService.cacheKEY('wpic_' + paymentId, idCard);
		}

        let payment = this.appService.user.wallet.payments.find((payment: any) => payment._id === paymentId);
        if (!payment) return Promise.reject(new Error('Cannot add cvv, related payment does not exists'));

		payment.cvv = cvv;
		if (idCard && idCard != 'MISSING') payment.idCard = idCard;

		let payload = _.cloneDeep(this.appService.user.wallet);
		_.remove(payload.payments, (_payment) => {
			if (!_payment["cvv"]) return true;
		})

        // This one will override the whole wallet, and only the cvv will keep at db
		return this.post(`${this.appConfig.tabitBridge}/customers/current/meta`, {wallet: payload}).then(userMeta => {
            return userMeta && userMeta.wallet;
		}).catch(err => {
			return;
		});
    }

	public removePaymentFromWallet(pmId) {
		let that = this;
		return this.remove('/online-shopper/customers/current/wallet/payments/' + pmId, {}).then(response => {
			return true;
		}).catch(e => {
			throw (e);
		});
	}

	public updateAccount(signin) {
		let customerData: any = {
			email: signin.email,
			oldPassword: signin.oldPassword,
			newPassword: signin.newPassword,
			name: signin.name,
			phone: signin.phone
		};

		let defaultWalletPayment = signin.defaultWalletPayment;
		let that = this;
		return this.put('/online-shopper/customers/current', customerData).then(response => {
			that.appService.user = that.authService.prepareUser(response);
			if (defaultWalletPayment) {
				return that.post('/online-shopper/customers/current/wallet/payments/' + defaultWalletPayment + '/default').then(response => {
					return that.getUserWallet();
				})
			}
			return that.getUserWallet();
		}).catch(e => {
			throw (e);
		});
	}

	async postPayment(parsedPayment, resultOrder, releaseOrder, retryCount?) {
		let that = this;
		var unlock = releaseOrder ? '1' : '0';
		parsedPayment.source = resultOrder.source || 'online';

		const logTip = _.get(parsedPayment, 'tip.amount', 0), logData: any = {
			data: {
				totalPayment: parsedPayment.amount,
				tipAmount: logTip,
				amountBeforeTip: parsedPayment.amount - logTip,
				account: parsedPayment.account,
				paymentType: parsedPayment.paymentType,
				paymentMode: this.appService.$storage.paymentMode
			}
		}

		let url = `/online-shopper/orders/${resultOrder._id}/payments/V2?unlock=${unlock}`;
		if (parsedPayment.isPreAuth) {
			url = `/online-shopper/orders/${resultOrder._id}/authorization-holds`;
		}

		return new Promise((resolve, reject) => {
			this.post(
				url,
				parsedPayment,
				{ 'ros-organization': resultOrder.organization }
			).then(res => {
				resolve(res);
			}).catch(srvErr => {
				let err = srvErr.error || {}
				logData.data.error = JSON.stringify(err);

				if (srvErr.type == 'PAYMENT_VALIDATION_ERROR') {
					reject(srvErr);
					that.appService.logTemplate("paymentFail", logData, "Payment Fail");
				}
				if (err.code == '409943' && err.data?.action) {
					document.getElementById('add_payment')["contentWindow"].call3DSAction(err.data.action);
					reject({ auth3D: true });
				} else if (retryCount < 3 && (err.code == '409100' || err.code == '409036')) {
					window.setTimeout(() => {
						that.postPayment(parsedPayment, resultOrder, releaseOrder, ++retryCount).then(response => {
							resolve(response);
						}).catch(err => {
							reject(err)
							that.appService.logTemplate("paymentFail", logData, "Payment Fail");
						});
					}, 5000);
					return;
				} else {
					let errDesc;
					switch (err.code) {
						case 409100: case 409036: errDesc = "MESSAGES.PAYMENT_LOCKED"; break;
						case 20106: errDesc = "MESSAGES.ORDER_NEWPAYMENT_NEEDED"; break;
						case 409047: errDesc = "MESSAGES.ORDER_REQUIERES_IDCARD"; break;
						case 409098: errDesc = "MESSAGES.SHVA_OFFLINE"; break;
						case 409188: errDesc = "MESSAGES.CARD_VALIDATION_MISMATCH"; break;
						case 400013: errDesc = "MESSAGES.INVALID_PAYMENT_AMOUNT"; break;
					}

					let appError = {
						type: 'PAYMENT_VALIDATION_ERROR',
						wasErrorDesc: errDesc != null,
						message: that.appService.translate(errDesc || "MESSAGES.PAYMENT_ERROR"),
						serverError: srvErr,
						code: err.code
					};
					reject(appError);
				}
			});
		});
	}
	async updateAuthPayment(orderId, authorizationId, amount) {
		let response;
		try {
			response = await this.patch(`/online-shopper/orders/${orderId}/authorization-holds/${authorizationId}`, {amount: amount}, { 'ros-organization': this.appService.getOrganization() });
		} catch (e) {
			throw (e);
		}
		return response;
	}
	async completeAuthPayment(orderId, authorizationId, amount, tipAmount = 0) {
		let response;
		try {
			response = await this.post(`/online-shopper/orders/${orderId}/authorization-holds/${authorizationId}/complete`, {amount: amount, tip: {amount: tipAmount}}, { 'ros-organization': this.appService.getOrganization() });
		} catch (e) {
			throw (e);
		}
		return response;
	}

	servicePost(params, enableRecaptcha?: boolean) {
		return this.post(params.url, params.data, { 'ros-organization': this.appService.getOrganization() }, enableRecaptcha);
	}
    public post(url, payload?, headers?, enableRecaptcha?: boolean): Promise<any> {
		return this.authService.callSignedHTTP('post', url, payload, headers, true, true, enableRecaptcha);
	}

	public put(url, payload?, headers?): Promise<any> {
		return this.authService.callSignedHTTP('put', url, payload, headers);
	}
	public patch(url, payload?, headers?): Promise<any> {
		return this.authService.callSignedHTTP('patch', url, payload, headers);
	}

	serviceGet(params, dontBlock?, errorInfo?) {
		return this.get(params.url, params.data, { 'ros-organization': this.appService.getOrganization() });
	}
	public get(url, payload?, headers?): Promise<any> {
		return this.authService.callSignedHTTP('get', url, payload, headers);
	}

    public remove(url, payload?, headers?): Promise<any> {
		return this.authService.callSignedHTTP('remove', url, payload, headers);
	}
	public removeWithBody(url, payload?, headers?): Promise<any> {
		return this.authService.callSignedHTTP('delete', url, payload, headers);
	}

	setStorage(key: string, data: any) {
		return new Promise((resolve, reject) => {
			try {
				localStorage.setItem(key, JSON.stringify(data));
				resolve(data);
			} catch (err) {
				console.error('Error saving to localStorage', err);
				reject(err);
			}
		});
	}

	getStorage(key: string) {
		return new Promise((resolve, reject) => {
			try {
				resolve(JSON.parse(localStorage.getItem(key)));
			} catch (err) {
				console.error('Error getting data from localStorage', err);
				reject(err);
			}
		});
	}

	public getSimulated(what, args?): Promise<any> {
		let sURL = "/assets/mock/";
		let resolved:any = null;
		let delay = 300;

		switch (what) {
			case "userHistory": sURL += "userHistory.json"; break;
			case "quickPayCode":
				delay = 1000;
				sURL += "any.json";
				resolved = {
					code: 1840,
					_id: "123456",
					expiresAt: moment().add(5, 'minutes').toDate()
				}
				break;
			default: sURL += "any.json"; break;
		}

		let that = this;
		return new Promise((resolve, reject) => {
			this.httpClient.get(sURL)
				.subscribe(
					(results: any) => {
						window.setTimeout(function () {
							resolve(resolved || results);
						}, delay);
					},
					(err) => {
						reject(err)
					}
				);
		});
	}


}
